<fui-chrome-control-dropdown [title]="'wbo.chrome.button.account'" (click)="profileClicked()">
    <fui-icon [height]="15" [icon]="'account'" [width]="18"></fui-icon>
    <div class="account">
        <div class="account-state">
            <div class="account-state-header">
                <div class="account-state-header-label">
                    <div class="account-state-header-label-title">
                        {{profileModel.data.firstName}} {{profileModel.data.lastName}}
                    </div>
                </div>
            </div>
            <div class="account-state-footer">
                <div *ngIf="profileModel.data.accessRole.name" class="account-state-footer-role">
                    <div class="account-state-footer-role-label">
                        <div class="account-state-footer-role-label-title">
                            <strong>{{'wbo.user-profile.label.accessRole' | translate}}:</strong>
                        </div>
                    </div>
                    <div class="account-state-footer-role-label">
                        <div class="account-state-footer-role-label-title">
                            {{profileModel.data.accessRole.name}}
                        </div>
                    </div>
                </div>
                <div class="account-state-footer-action">
                    <fui-local-button (click)="logout()" [title]="'wbo.common.label.logout'"></fui-local-button>
                </div>
            </div>
        </div>
    </div>
</fui-chrome-control-dropdown>
